import * as React from 'react'
import AnnounceKit from 'announcekit-react'

interface Props {
  userId: string
  email?: string | null
  companyId: number
  companyName: string
  province: string | null
}

export class AnnounceKitBadge extends React.PureComponent<Props> {
  private ref = React.createRef<AnnounceKit>()
  constructor(props: Props) {
    super(props)
  }

  componentDidMount = async () => {
    const unreadPostCount = await this.unreadPostCount()

    if (unreadPostCount !== 0) {
      this.ref.current?.open()
    }
  }

  unreadPostCount = async () => {
    return this.ref.current?.unread()
  }

  render() {
    return (
      <AnnounceKit
        catchClick='.ak-trigger'
        ref={this.ref}
        widget='https://announcekit.app/widgets/v2/1wkSg8'
        widgetStyle={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '0.9em',
          height: '0.9em',
        }}
        user={{
          id: this.props.userId,
          email: this.props.email,
        }}
        data={{
          company_id: this.props.companyId,
          company_name: this.props.companyName,
          province: this.props.province,
        }}
      />
    )
  }
}
